export default __webpack_public_path__ + "static/media/experience1.7292ec75.png";